import Autoplay from 'embla-carousel-autoplay';
import { useCallback, useEffect, useState } from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselApi } from '../ui/carousel';
import useEmblaCarousel from 'embla-carousel-react';
import Image from 'next/image';
type CarouselSection = {
  slides: string[];
  name?: string | null;
};
function ProductCarouselDesktop(props: CarouselSection) {
  const [carouselApi, setCarouselApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
    containScroll: 'keepSnaps',
    dragFree: true,
  });

  useEffect(() => {
    if (!carouselApi) {
      return;
    }
    setCurrent(carouselApi?.selectedScrollSnap() + 1);
    carouselApi.on('select', () => {
      setCurrent(carouselApi.selectedScrollSnap() + 1);
    });
  }, [carouselApi]);
  const onThumbClick = useCallback(
    (index: number) => {
      if (!carouselApi || !emblaThumbsApi) return;
      carouselApi.scrollTo(index);
    },
    [carouselApi, emblaThumbsApi],
  );

  const onSelect = useCallback(() => {
    if (!carouselApi || !emblaThumbsApi) return;
    setCurrent(carouselApi.selectedScrollSnap());
    emblaThumbsApi.scrollTo(carouselApi.selectedScrollSnap());
  }, [carouselApi, emblaThumbsApi, setCurrent]);

  useEffect(() => {
    if (!carouselApi) return;
    onSelect();
    carouselApi.on('select', onSelect);
    carouselApi.on('reInit', onSelect);
  }, [carouselApi, onSelect]);
  return (
    <div className="flex h-full w-full flex-col items-start justify-start">
      <Carousel
        dir="ltr"
        plugins={[Autoplay({ delay: 10_000 })]}
        setApi={setCarouselApi}
        className="w-full"
      >
        <CarouselContent className="mx-0 h-full w-full">
          {props.slides.map((item, index) => (
            <CarouselItem key={index} className="aspect-[4/4.5] h-full w-full pl-0">
              <Image
                className="h-full w-full rounded-lg object-cover"
                alt={``}
                width={1000}
                height={1000}
                src={item}
                priority
              />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      <div className="overflow-hidden" ref={emblaThumbsRef}>
        <div className="mt-2 flex gap-4">
          {props.slides.map((url, index) => (
            <Thumb
              onClick={() => onThumbClick(index)}
              selected={index === current}
              index={index}
              imgSrc={url}
              key={index}
              name={props.name}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

type PropType = {
  selected: boolean;
  imgSrc: string;
  index: number;
  onClick: () => void;
  name?: string | null;
};

export const Thumb: React.FC<PropType> = (props) => {
  const { selected, imgSrc, onClick } = props;

  return (
    <div
      data-selected={selected ? 'true' : 'false'}
      className={
        'relative transition-all data-[selected=false]:opacity-20 data-[selected=true]:opacity-100'
      }
    >
      <button
        onClick={onClick}
        className="block cursor-pointer touch-manipulation bg-transparent transition-all"
        type="button"
        aria-label="Product Image"
      >
        <Image
          src={imgSrc}
          className="aspect-square h-40 w-40 rounded-lg object-cover"
          alt={``}
          width={250}
          height={250}
          priority
        />
      </button>
    </div>
  );
};

export default ProductCarouselDesktop;
